import { useTranslation } from 'react-i18next';
import React, { useCallback, useState } from 'react';
//import './App.css';
import {
  LoginUser,
  LoginPassword,
  LoginDevice,
  ErrorBoundary,
} from './components';
import {
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import {AppBar, Box, Typography} from "@mui/material";
import { useLocalStorage } from './utils/hooks';
import { LOCAL_STORAGE_KEY } from './constants/localStorage';
import {DEBUG_FLAG} from './constants/debug';
import FormPreview from './components/FormularGenerator/FormPreview';
import { FullPageSpinner } from './components/lib';
import LoadingComponent from './components/LoadingComponent/LoadingComponent';
function UnauthenticatedApp() {
  const { t } = useTranslation();
  const [username, setUsername] = useLocalStorage(LOCAL_STORAGE_KEY.username);
  const [refreshToken, ] = useLocalStorage(LOCAL_STORAGE_KEY.refreshToken);
  const [useDeviceAuth, ] = useLocalStorage(LOCAL_STORAGE_KEY.useDeviceAuth);
  const [deviceLogin, setDeviceLogin] = useState(true);
  const renderLogin = useCallback(() => {
    if (username) {
      if (refreshToken !== '' && deviceLogin && useDeviceAuth === 'true') {
        return(<LoginDevice doPasswordLogin={() => setDeviceLogin(false)}/>);
      } else {
        return(<LoginPassword/>);
      }
    } else {
      return(<LoginUser />);
    }
  }, [refreshToken, username, deviceLogin, useDeviceAuth]);

  if (username && window && window.location && window.location.pathname && window.location.pathname.toLowerCase() === '/sso' && window.location?.search.startsWith('?domain=') && window.location.search !== '?domain='+username.slice(1)) {
    setUsername('');
    return;       
  }

  return (
    <Box pt={10}>
      {DEBUG_FLAG() && 
      <AppBar style={{backgroundColor: '#ffffff00'}}>
        <Typography variant="h6" color="error">
            {t("-LOKAL-")}
        </Typography>
      </AppBar>}
      <Routes>
        <Route
            path="/formpreview/:formKey"
            element={
              <ErrorBoundary errorComponent="FormPreview">
                <FullPageSpinner/>
              </ErrorBoundary>
            }
          />
        <Route path="/*"
          element={renderLogin()}>
          </Route>
      </Routes>
    </Box>
  );
}
export default UnauthenticatedApp;
